import axios from 'axios';
import config from "./config";

export interface HttpRes {
    data: any,
    error: boolean,
    errCod?: number,
    errMsg?: string,
}

export default class Http {

    private url = `${config.API_URL}`
    private static peticiones: string[] = [];
    // private url = `http://localhost:8889`
    // private url = `http://boletera.com.mx:8889`

    //   constructor() {

    //   }

    static async post(ep: any, data: any, auth = true, responseType: any = undefined, files = false): Promise<HttpRes> {
        let HttpReq = new Http();
        let Url = `${HttpReq.url}/${ep}`;
        try {
            const Auth = localStorage.getItem('tt')
            let Location = window.location.href.split('?')[0];
            Location = Location.replace("www.", "");
            if (auth) {
                Url = `${HttpReq.url}/auth/${ep}`;
                if (!Auth) {
                    window.location.reload();
                }
            }
            if (!this.peticiones.includes(Url)) {
                this.peticiones.push(Url);
            } else {
                return { data: null, error: true, errCod: 999, errMsg: 'Guardando...' };
            }
            let AxReq = await axios.post(Url, data, {
                headers: { 
                    Auth, 
                    Location,
                },
                responseType,
            });
            this.peticiones = this.peticiones.filter(p => p !== Url)
            return AxReq.data;
        } catch (e) {
            console.log(e);
            this.peticiones = this.peticiones.filter(p => p !== Url)
            const err = e as any;
            const errMsg = err?.response?.data?.errMsg || err?.response?.data?.message || err?.message || 'Error de conexión';
            return { data: null, error: true, errCod: err?.response?.status || 0, errMsg };
        }
    }
    
    static async get(ep: any, auth = true, responseType: any = undefined): Promise<HttpRes> {
        let HttpReq = new Http();
        try {
            var Url = `${HttpReq.url}/${ep}`;
            const Auth = localStorage.getItem('tt');
            let Location = window.location.href.split('?')[0];
            Location = Location.replace("www.", "");
            if (auth) {
                Url = `${HttpReq.url}/auth/${ep}`;
                if (!Auth) {
                    window.location.reload();
                }
            }
            let AxReq = await axios.get(Url, {
                headers: { 
                    Auth,
                    Location,
                },
                responseType,
            });
            return AxReq.data;
        } catch (e) {
            const err = e as any;
            const errMsg = err?.response?.data?.errMsg || err?.response?.data?.message || err?.message || 'Error de conexión';
            return { data: null, error: true, errCod: err?.response?.status || 0, errMsg };
        }
    }

}